import { Component } from '@angular/core';
import { Restatement } from "../../domains/Restatement";

@Component({
  selector: 'app-restatement',
  templateUrl: './restatement.component.html',
  styleUrls: ['./restatement.component.less'],
  standalone: false
})
export class RestatementComponent {
  public restatementDocs: Restatement[];
  dontShowStep1 = false;
  dontShowStep2 = true;

  childEventClicked(aaSelected: Restatement[]) {
    if (aaSelected.length > 0) {
      this.restatementDocs = aaSelected;
      this.dontShowStep1 = true;
      this.dontShowStep2 = false;
    }
  }

  backButtonClicked(back: boolean) {
    if (back) {
      this.dontShowStep1 = false;
      this.dontShowStep2 = true;
    }
  }

  navigateToStep2(aaSelected: Restatement[]) {
    // let url = constants.uiRoutes.goToCompleteUrl.url;
    // window.location.href = url;
    this.restatementDocs = aaSelected;
    this.dontShowStep1 = true;
    this.dontShowStep2 = false;
  }

}
